import React, { createContext, useContext, ReactNode } from 'react';
import { ConversationGroupResponseDto } from '../../../../../store/rtk-query/apis/outreach/dto/response/conversations-groups-response.dto';
import { useConversationGroupsInfiniteQuery, UseConversationGroupsInfiniteQueryReturn } from './conversation-groups-infinite-query.hook';

// Context type
interface ConversationGroupsInfiniteProviderProps {
  positionId: string;
  conversationGroups: ConversationGroupResponseDto[];
  children: ReactNode;
}

const ConversationGroupsInfiniteContext = createContext<UseConversationGroupsInfiniteQueryReturn | undefined>(undefined);

export const ConversationGroupsInfiniteProvider = ({
  positionId,
  conversationGroups,
  children,
}: ConversationGroupsInfiniteProviderProps): JSX.Element => {
  const value = useConversationGroupsInfiniteQuery({ positionId, conversationGroups });

  return (
    <ConversationGroupsInfiniteContext.Provider value={ value }>
      {children}
    </ConversationGroupsInfiniteContext.Provider>
  );
};

export const useConversationGroupsInfinite = (): UseConversationGroupsInfiniteQueryReturn => {
  const ctx = useContext(ConversationGroupsInfiniteContext);
  if (!ctx) throw new Error('useConversationGroupsInfinite must be used within ConversationGroupsInfiniteProvider');

  return ctx;
};
